import { GlobalOnexConfig, STATUS_QUO } from '@otto-ec/eprivacy-onex'

export const config: GlobalOnexConfig = {
  active: false,
  id: 'E3555',
  smoketestsIncludeOnex: false,
  localE2eTestsIncludeOnex: {
    runVisualE2eTests: false,
    runFunctionalE2eTests: false,
  },
  activeOnexConfig: {
    [STATUS_QUO]: {
      template: 'cookieBanner-onetrust.html',
      styleFile: 'styles-onetrust.scss',
    },
    NewConsB: {
      styleFile: 'styles-onetrust--slide-in-fast.scss',
    },
    NewConsC: {
      styleFile: 'styles-onetrust--slide-in-slow.scss',
    },
  },
}
